<template>
  <div class="divBox" v-loading="uploadLoading" element-loading-spinner="el-icon-loading"
       element-loading-text="上一个视频正在上传，下一个视频即将开始录制，请不要进行任何操作，请稍等...">
    <el-card class="box-card" style="min-height: 500px">
      <el-form
          ref="formValidate"
          class="formValidate mt20"
          label-width="160px"
          v-model="formValidate"
          @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="快递单号：" prop="express_num">
              <el-input id="equip" v-model="formValidate.express_num" style="width: 300px" ref="expNum" :focus="fouse"
                        @input="getOrderByExpFn"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div
                style="position: fixed;top:0;display: flex;flex-direction: column;right: 50px;align-items: center;z-index: 10">
              <div style="z-index: 10;font-size: 24px;color: red;position: absolute;top: 200px;letter-spacing: 2px;display: flex;flex-direction: column;align-items: center">
                {{ isRecording ? '视频录制中...' : '' }}
                <p v-if="recordInter">
                  {{recordTime}}s
                </p>
              </div>
              <video id="video" :width="960" :height="800">
              </video>
              <div style="display: flex">
                <!--                <el-button size="mini" @click="startVideoFn" type="primary">开始</el-button>-->
                <el-button size="mini" @click="stopVideoFn(false)" type="primary">停止录制不上传</el-button>
                <el-button size="mini" @click="stopVideoFn(true,'onLoad')" type="primary">停止录制并上传视频</el-button>
                <a ref="updateVideo" :href="videoCosUrl"></a>
              </div>
              <video v-if="false" id="video2" v-show="videoUrl" controls autoplay :src="videoUrl" :width="300"
                     :height="300">
              </video>
              <div v-if="false"
                   style="z-index: 10;font-size: 24px;color: red;position: absolute;bottom: 120px;letter-spacing: 2px">
                {{ videoUrl ? '上一个入库视频...' : '' }}
              </div>
            </div>
          </el-col>
          <el-col :span="24" v-if="oldExp">
            <el-form-item label="当前录制的快递单号："><span style="font-size: 18px;color: red">{{ oldExp }}</span>
            </el-form-item>
          </el-col>
          <template v-if="orderInfo.recovery_order_id">
            <el-col :span="24">
              <el-form-item label="是否到付：" prop="express_num">
              <div style="display: flex;align-items: center;height:36px;">
                <el-switch
                  style="display: flex;align-items: center;flex-wrap: nowrap;white-space: nowrap;line-height:22px;margin-left: 20px"
                  v-model="formValidate.express_pay_status"
                  active-color="#ff4949"
                  :width="50"
                  :active-value="1"
                  :inactive-value="0"
                  active-text=""
                  inactive-text="">
                </el-switch>
                <el-input v-model="express_remark" v-if="formValidate.express_pay_status" style="width: 200px;margin-left: 20px" placeholder="请输入到付备注"></el-input>
              </div>
              </el-form-item>
            </el-col>

          </template>
          <template v-if="orderInfo.recovery_order_id">
            <el-col :span="24">
              <el-form-item :label="'物流信息'+(index+1)+'：'" prop="express_num"
                            v-for="(item,index) in orderInfo.express_list">
                {{ item.express_company }} - 【{{ item.express_num }}】 - <span class="status"
                                                                              :style="item.express_status == 1 ? 'color:#B5B5B8' : 'color:#ED4655'">
                {{ statusFn(item) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="商品信息：" v-if="orderInfo.product_list?orderInfo.product_list.length:false">
                <div class="list" v-for="(item,index) in orderInfo.product_list">
                  <div style="font-weight: bold;font-size: 18px">{{ item.category_name }}：</div>
                  <div class="item" v-for="(item1,index1) in item.sku_list">
                    <span>{{ skuFn(item1) }}</span>
                    <span style="margin-left: 40px;font-size: 14px;font-weight: bold">数量x{{ item1.num }}</span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <el-form-item style="margin-top:30px;" v-if="is_search">
          <!--          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交-->
          <!--          </el-button>-->
        </el-form-item>
      </el-form>
    </el-card>


    <el-dialog
        title="温馨提示"
        :visible.sync="VisibleShow"
        width="30%"
        :before-close="handleClose">
      <span>{{ formValidate.express_num }} 该物流单号暂未报单，请仔细核对后确认是否继续录制</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="confirmFn">确 定 录 制</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  addVideoApi,
  uploadVideoApi,
  recoveryOrderDetailByExpNumApi, stockGetTempKeysApi
} from "@/api/recovery";
import {getNowDateFn} from "@/utils/timeOptions";
import Cos from "cos-js-sdk-v5";

const defaultObj = {
  express_num: '',
}
export default {
  name: 'warehousing',
  data() {
    return {
      videoCosUrl: '',
      fouse: true,
      waterCof: null,
      isOne: true,
      recordInter:null,
      express_pay_status:0,

      oldExp: null,
      oldExpNum: null, //
      canUpload: true,//是否能上传提交视频
      isRecording: false,
      auditMessageArr: [],
      uploadLoading: false,
      videoUrl:'',
      recordedChunks: [],
      VisibleShow: false,
      recordTime:1,
      loadType: '',
      videoUrl: null,
      imgif: false,
      contextCamera: null,
      canvasCamera: null,
      videoCamera: null,
      is_search: false,
      orderInfo: {recovery_order_id: null},
      isSearchExp: null,
      is_alike:false,
      fullscreenLoading: false,
      express_remark:'此快递为到付',
      formValidate: {
        express_num: '',
        sku_list: [],
        express_pay_status:0,
        image: []
      },
      loading: false,
    }
  },
  computed: {
    skuFn() {
      return function (item) {
        if (item.sku) {
          let arr = item.sku.split(',')
          if (arr.length > 1) {
            return arr[0] + '+' + arr[1]
          } else {
            return item.sku
          }
        } else {
          return item.sku
        }
      }
    },
    statusFn() {
      return function (item) {
        return item.express_status == 1 ? '已入库' : '待入库'
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.expNum.focus()
    })
    this.getPicOrVideoFn()
    this.getwaterCofFn()

  },
  methods: {

    async uploadWaterFn() {//上传视频
      let that = this
      let expressNum = this.oldExpNum ? this.oldExpNum : this.oldExp
      let params = {express_num: expressNum, express_video: that.videoCosUrl,express_pay_status:this.formValidate.express_pay_status}
      if(this.formValidate.express_pay_status==1){
        params.express_remark=this.express_remark
      }
      await addVideoApi(params)
      console.log(that.videoCosUrl)
      // fetch(that.videoCosUrl)
      //   .then(res => res.blob())
      //   .then(blob => {
      //     const a = document.createElement("a");
      //     const objectUrl = window.URL.createObjectURL(blob);
      //     a.download = expressNum + '_' +new Date()
      //     a.href = objectUrl;
      //     a.click();
      //     window.URL.revokeObjectURL(objectUrl);
      //     a.remove();
      //   })
      this.$message.success('提交成功')
      this.formValidate.express_pay_status=0
      this.express_remark = '此快递为到付'
      let exp = JSON.parse(JSON.stringify(that.formValidate.express_num))
      that.oldExp = exp
      that.uploadLoading = false
      this.getNumFn()
      if (!that.orderInfo.recovery_order_id) {
        that.oldExp = ''
      }
      if (that.loadType == 'onLoad') {
        // window.location.reload()
        that.is_search = false
        that.isOne = true
        that.oldExp = ''
        that.$nextTick(() => {
          that.$refs.expNum.focus()
        })
        that.orderInfo = {
          recovery_order_id: null
        }
      }
      that.formValidate.express_num = ''
      that.formValidate.sku_list = []
    },
    getNumFn() {
      if (this.orderInfo.express_list) {
        for (let i = 0; i < this.orderInfo.express_list.length; i++) {
          if (this.formValidate.express_num.toLowerCase() == this.orderInfo.express_list[i].express_num.toLowerCase()) {
            this.oldExpNum = JSON.parse(JSON.stringify(this.orderInfo.express_list[i].express_num))
          }
        }
      } else {
        this.oldExpNum = null
      }

    },
    addWatermarkFn() {//视频添加水印
      let that = this
      let strList = that.videoCosUrl.split('/')
      that.videoUrl =  that.videoCosUrl
      let src = strList[strList.length - 3]+'/'+strList[strList.length - 2] + '/' + strList[strList.length - 1]
      console.log(src)
      const config = this.waterCof
      const host = config.bucket + '.ci.' + config.region + '.myqcloud.com';
      const url = 'https://' + host + '/jobs';
      const InputConf = {
        Bucket: config.bucket,
        Region: config.region,
        FileName: src,
        WaterMark: 'def/waterlogo.png'
      };
      const OutputConf = {
        Bucket: config.bucket,
        Region: config.region,
        FileName: src + '.mp4',
      };
      const imageWaterMarkUrl = InputConf.Bucket + '.cos.' + InputConf.Region + '.myqcloud.com/' + InputConf.WaterMark
      const picWatermark = {
        "Type": "Image", // 水印类型  Image：图片水印
        "Dx": "10", // 水平偏移
        "Dy": "10", // 垂直偏移
        "LocMode": "Absolute", // 偏移方式 Relativity：按比例，Absolute：固定位置
        "Pos": "TopLeft", // 基准位置 TopRight、TopLeft、BottomRight、BottomLeft、Left、Right、Top、Bottom、Center
        "Image": { // 图片水印参数
          "Height": 120, // 高
          "Width": 120, // 宽
          "Mode": "Original", //尺寸模式 1. Original：原有尺寸,2. Proportion：按比例,3. Fixed：固定大小
          "Transparency": "100", // 透明度
          "Background": false, // 是否为背景图
          "Url": imageWaterMarkUrl // 水印图地址，支持GIF,PNG,MOV,APNG,JPG格式（gif和apng格式图片水印会在持续时间内循环播放）
        }
      }

      const txtWatermark = {
        "Type": "Text", // 水印类型  Text：文字水印
        "Dx": "10", // 水平偏移
        "Dy": "10", // 垂直偏移
        "LocMode": "Absolute", // 偏移方式 Relativity：按比例，Absolute：固定位置
        "Pos": "BottomLeft", // 基准位置 TopRight、TopLeft、BottomRight、BottomLeft、Left、Right、Top、Bottom、Center
        "Text": { // 文字水印参数
          "FontColor": "0x000000", // 字体颜色
          "FontSize": 50, // 字体大小
          "FontType": "simfang.ttf", // 字体类型
          "Text": getNowDateFn(), // 水印内容，长度不超过64个字符，仅支持中文、英文、数字、_、-和*
          "Transparency": "100" // 透明度
        },
      }
      const txtWatermarkExp = {
        "Type": "Text", // 水印类型  Text：文字水印
        "Dx": "10", // 水平偏移
        "Dy": "70", // 垂直偏移
        "LocMode": "Absolute", // 偏移方式 Relativity：按比例，Absolute：固定位置
        "Pos": "BottomLeft", // 基准位置 TopRight、TopLeft、BottomRight、BottomLeft、Left、Right、Top、Bottom、Center
        "Text": { // 文字水印参数
          "FontColor": "0x000000", // 字体颜色
          "FontSize": 50, // 字体大小
          "FontType": "simfang.ttf", // 字体类型
          "Text": '扫码单号：' + that.oldExp, // 水印内容，长度不超过64个字符，仅支持中文、英文、数字、_、-和*
          "Transparency": "100" // 透明度
        },
      }
      // SecretId: 'AKIDpeNr581mQ4YoEWgfR3b8mR6au41jBPbe', // 临时密钥的 tmpSecretId
      //  SecretKey: 'z62kT7bwH7rQlphQvGZkrmXHo8HMNQOM', //
      let cos = new Cos({
        SecretId: 'AKIDpeNr581mQ4YoEWgfR3b8mR6au41jBPbe', // 临时密钥的 tmpSecretId
        SecretKey: 'z62kT7bwH7rQlphQvGZkrmXHo8HMNQOM', // 临时密钥的 tmpSecretKey
        //XCosSecurityToken: config.credentials.sessionToken, // 临时密钥的 sessionToken
        //ExpiredTime: config.expiredTime // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
      })

      const body = Cos.util.json2xml({
        Request: {
          "Tag": "Transcode", /* 创建任务的类型是 Watermark ,必须*/
          "Input": {
            "Object": InputConf.FileName, /* 需要的视频文件，存储桶里的路径，必须 */
          },
          "Operation": {
            "Output": {
              "Region": OutputConf.Region, /* 存储桶的地域，必须 */
              "Bucket": OutputConf.Bucket, /* 存储结果的存储桶，必须 */
              "Object": OutputConf.FileName /* 输出结果的文件名，必须 */
            },
            "Watermark": [picWatermark, txtWatermark, txtWatermarkExp],
            "Transcode": {
              "Container": {
                "Format": 'mp4'
              },
              "Video": {
                "Codec": 'H.264'
              }
            }
          }
        },
      });
      cos.request(
          {
            Bucket: InputConf.Bucket,
            Region: InputConf.Region,
            Method: 'POST',
            Url: url,
            Key: '/jobs', /** 固定值，必须 */
            ContentType: 'application/xml', /** 固定值，必须 */
            Body: body
          },
          (err, data) => {
            if (data.Response.JobsDetail.Code == 'Success') {
              that.videoCosUrl = that.videoCosUrl + '.mp4'

              that.uploadWaterFn()
            }

          }
      );
    },
    async getwaterCofFn() {//获取水印配置
      let {data} = await stockGetTempKeysApi()
      this.waterCof = data
    },
    // 搜索不出不需要录入
    handleClose() {
      this.clearFormFn()
      this.VisibleShow = false
    },
    // 搜索不出继续录制
    confirmFn() {
      this.VisibleShow = false
      this.orderInfo = {recovery_order_id: 999}
      this.formValidate.express_num = ''
      document.getElementById('equip').focus()
      console.log('confirm')
      this.startVideoFn()
    },
    startVideoFn() {
      this.recordInter = setInterval(()=>{
        this.recordTime++
      },1000)
      this.recordedChunks = []
      this.mediaRecorder.start()
      this.isRecording = true
      this.canUpload = true

    },
    stopVideoFn(e = true, type) {
      this.loadType = type
      this.canUpload = e
      this.mediaRecorder.stop()
    },
    getPicOrVideoFn() {//获取摄像头
      let _this = this
      this.videoCamera = document.getElementById('video')

      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          let getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      var constraints = {
        audio: false,
        video: true
      }
      navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
        // 旧的浏览器可能没有srcObject
        if ('srcObject' in _this.videoCamera) {
          _this.videoCamera.srcObject = stream
        } else {
          // 避免在新的浏览器中使用它，因为它正在被弃用。
          _this.videoCamera.src = window.URL.createObjectURL(stream)
        }
        const mime = MediaRecorder.isTypeSupported("video/webm; codecs=vp9")
            ? "video/webm; codecs=vp9"
            : "video/webm";
        _this.mediaRecorder = new MediaRecorder(stream, {mimeType: mime})
        _this.mediaRecorder.ondataavailable = function (e) {
          _this.recordedChunks.push(e.data);
        };
        // 获取video track
        const videoTrack = stream.getVideoTracks()[0];
        // 获取分辨率信息
        const { width, height } = videoTrack.getSettings();
        console.log(width,height,'00000000000000')
        // 设置分辨率和帧率
        const constraints = {
          width: { ideal: 1920 },
          height: { ideal:  1080},
          frameRate: { ideal: 30, max: 60 }
        };
        videoTrack.applyConstraints(constraints);

        _this.videoCamera.onloadedmetadata = function (e) {
          _this.videoCamera.play()
        }
        _this.mediaRecorder.onstop = () => {
          _this.recordTime = 1
          clearInterval(_this.recordInter)
          _this.isRecording = false
          if (_this.canUpload === true) {
            const recordedBlob = new Blob(_this.recordedChunks, {type: 'video/webm'});
            _this.videoUrl = recordedBlob;
            if(_this.is_alike){ // 判断这一次和上一次的物流单号是否一致
              _this.is_search = true
            }else{
              _this.is_search = false
            }
            _this.uploadVideoFn()
            _this.handleSubmit()
          } else {
            _this.videoUrl = ''
            _this.is_search = false
            _this.orderInfo = {recovery_order_id: null}
            window.location.reload()
            if (_this.formValidate.express_num.trim()) {
              _this.getOrderDetailsFn()
            }
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    async getOrderDetailsFn() {//搜索订单详情
      let that = this
      this.fullscreenLoading = true
      // this.formValidate.express_num = ''
      let res = await recoveryOrderDetailByExpNumApi({express_num: this.formValidate.express_num})
      this.fullscreenLoading = false
      if (res.data.detail) {
        let list = []
        this.orderInfo = res.data.detail
        // this.oldExp = this.formValidate.express_num
        res.data.detail.express_list.some((v, i) => {
          if (that.formValidate.express_num.toLowerCase() == v.express_num.toLowerCase()) {
            if (this.isOne) {
              this.getNumFn()
            }
            if (!v.express_status) {
              that.formValidate.express_video = []
              that.formValidate.image = []
              that.formValidate.express_remark = '' // 入库备注
              res.data.detail.product_list.map((item1, index1) => {
                item1.sku_list.map((item, index) => {
                  list.push({
                    sku: item.sku,
                    image: [],
                    remark: '',
                    is_worn: 0,
                    num: item.num,
                    recovery_category_id: item1.recovery_category_id,
                    worn_num: '', //异常数量
                    is_Show: false,
                    batch_list: [],
                  })
                })
              })
            } else {
              if (that.formValidate.express_num == v.express_num) {
                that.formValidate.express_video = v.express_video
                that.formValidate.image = v.express_image
                that.formValidate.express_remark = v.express_remark // 入库备注
              }
              v.product_list.map((item, index) => {
                item.sku_list.map((item2, index2) => {
                  if (item2.batch_list) {
                    if (!item2.batch_list.length) {
                      item2.batch_list = []
                    }
                  } else {
                    item2.batch_list = []
                  }
                  item2.recovery_category_id = item.recovery_category_id
                  list.push(item2)
                })
              })
            }
            if (this.isOne) {
              this.formValidate.express_num = ''
            }
            return true
          }
        })
        this.formValidate.sku_list = list
        this.formValidate.express_list = res.data.detail.express_list
        this.is_search = true
        this.isOne = false
        console.log('详情')
        this.startVideoFn()
      } else {
        this.oldExpNum = null
        // this.$message({
        //   message: '没有搜索到订单信息',
        //   type: 'error',
        //   duration: 3000,
        //   showClose: true,
        //   offset: 300
        // })
        document.getElementById('equip').blur()
        this.VisibleShow = true
        return

        // this.formValidate.express_num = ''
      }
    },
    // 清除信息
    clearFormFn() {
      let num = ''
      this.formValidate = {
        express_num: num,
        image: [],
        express_remark: '',
        is_worn: 0,
        express_video: [],
        sku_list: [],
      }
      this.oldExp = ''
      this.isOne = true
      this.orderInfo = {recovery_order_id: null}
      this.is_search = false
    },
    getOrderByExpFn(e) {//扫码枪识别快递
      if (e.trim()) {
        if (this.isSearchExp) clearTimeout(this.isSearchExp)
        this.isSearchExp = setTimeout(() => {
          this.formValidate.express_num = (this.formValidate.express_num.trim()).toUpperCase()
          if (this.orderInfo.recovery_order_id) {
            if((this.formValidate.express_num.trim()).toUpperCase() == this.oldExp){
              this.is_alike = true
              this.stopVideoFn(true,'onLoad')
            }else{
              this.is_alike = false
              this.stopVideoFn()
            }
          } else {
            let exp = JSON.parse(JSON.stringify(this.formValidate.express_num))
            this.oldExp = exp
            this.handleSubmit()
          }
        }, 1000)
      }
    },
    uploadVideoFn(){

      let videoUrl = URL.createObjectURL(this.recordedChunks[0], {type: 'video/mp4'});
      this.mediaRecorder.srcObject = null;
      this.download(videoUrl)

    },
    download(e){
      const url = e;
      const name = this.oldExp +'_' +new Date().toISOString()
	    const a = document.createElement('a');
      a.style.display = 'none';
      a.download = `${name}.mp4`;
      a.href = url;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(e);
    },
    // 上传视频并提交
    handleSubmit() {
      let key = 'media/' + getNowDateFn().split('_')[0] + '/' + new Date().getTime() + 'zhemmei.mp4'
      let that = this
      let config = this.waterCof
      this.$nextTick(async () => {
        //上传视频
        if (this.orderInfo.recovery_order_id) {
          this.uploadLoading = true
          const formData = new FormData();
          const file = new File([this.videoUrl], 'a.webm', {type: 'video/mp4'});
          console.log(file)

          let cos = new Cos({
            SecretId: 'AKIDpeNr581mQ4YoEWgfR3b8mR6au41jBPbe', // 临时密钥的 tmpSecretId
            SecretKey: 'z62kT7bwH7rQlphQvGZkrmXHo8HMNQOM', // 临时密钥的 tmpSecretKey
            //XCosSecurityToken: config.credentials.sessionToken, // 临时密钥的 sessionToken
            //ExpiredTime: config.expiredTime // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
          })

          cos.sliceUploadFile({
            Bucket: config.bucket, /* 必须 */
            Region: config.region, /* 必须 */
            Key: key, /* 必须 */
            Body: file, // 上传文件对象
            onProgress: function (progressData) {
              //uploading(progressData)
            }
          }, function (err, data) {
            if (err) {
              that.$message.error(err)
              return
            }
            that.videoCosUrl = config.cdn ? config.cdn + key : 'https://' + data.Location
            console.log(that.videoCosUrl)
            that.uploadWaterFn()
          })
          return
          formData.append('file', file, 'a.mp4');
          let res = await uploadVideoApi(formData, {headers: {"content-type": "multipart/form-data"}})
          if (res.status == 200) {
            that.videoCosUrl = res.data.src
            that.addWatermarkFn()
          } else {
            that.uploadLoading = false
            that.$message({
              message: res.message,
              type: 'error'
            })
          }
          return
          let xhr = new XMLHttpRequest();
          xhr.open('GET', this.videoUrl, true);
          xhr.responseType = 'blob';
          xhr.onload = async function (e) {
            if (this.status == 200) {
              let blob = new Blob([this.response], {type: 'video/mp4'});
              // 使用blob对象进行操作
              const file = new File([blob], 'a.webm', {type: 'video/mp4'});
              formData.append('file', file, 'a.mp4');
              let res = await uploadVideoApi(formData, {headers: {"content-type": "multipart/form-data"}})
              if (res.status == 200) {
                that.videoCosUrl = res.data.src
                that.addWatermarkFn()
              } else {
                that.uploadLoading = false
                that.$message({
                  message: res.message,
                  type: 'error'
                })
              }
              return

            }
          };
          xhr.send();
        }
      })
      if (!this.is_search) {
        if (this.formValidate.express_num.trim()) {
          this.getOrderDetailsFn()
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-upload--picture-card {
  display: none;
}

::v-deep .el-upload-list__item {
  transition: none !important;
}

.label_tip {
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}

.selWidth {
  width: 100%;
}

.selWidthd {
  width: 300px;
}

.dialog-scustom, .addDia {
  min-width: 400px;
  height: 900px;

  .el-dialog {
    width: 400px;
  }

  h3 {
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}

.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

.agreement {
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0, 0, 0, .2);
  padding: 26px;
  border-radius: 15px;

  .content {
    height: 600px;
    overflow-y: scroll;

    /deep/ p {
      font-size: 13px;
      line-height: 22px;
    }
  }

  /deep/ img {
    max-width: 100%;
  }

  p {
    text-align: justify;
  }
}

/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track {
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}

.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}

.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}

.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}

.uploadVideo {
  margin-left: 10px;
}

.perW50 {
  width: 50%;
}

.submission {
  margin-left: 10px;
}

.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}

.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

</style>
